import React, { useMemo } from 'react'
import { ButtonBase, ButtonBaseProps, withLinkWrapper, TextProps } from '.'
import { theme } from 'theme'

interface ButtonPrimaryProps extends ButtonBaseProps {
    themeColor?:
        | 'astronautFont'
        | 'astronaut'
        | 'orange'
        | 'green'
        | 'red'
        | 'orangeFont'
        | 'blackOutline'
        | 'governorBayOutline'
        | 'disabled'
        | 'governorBay'
}

const themeStyle = {
    astronautFont: {
        bg: theme.newColors.neutral50,
        fontColor: theme.colors.astronaut,
        border: 'none',
    },
    astronaut: {
        bg: theme.colors.astronaut,
        fontColor: theme.newColors.neutral50,
        border: 'none',
    },
    orange: {
        bg: theme.colors.orange,
        fontColor: theme.newColors.neutral50,
        border: 'none',
    },
    green: {
        bg: theme.colors.jungleGreen,
        fontColor: theme.newColors.neutral50,
        border: 'none',
    },
    red: {
        bg: theme.colors.frenchRose,
        fontColor: theme.newColors.neutral50,
        border: 'none',
    },
    orangeFont: {
        bg: theme.newColors.neutral50,
        fontColor: theme.colors.orange,
        border: 'none',
    },
    blackOutline: {
        bg: theme.newColors.neutral50,
        fontColor: theme.colors.black,
        border: '1px solid black',
    },
    governorBay: {
        bg: theme.colors.governorBay,
        fontColor: theme.newColors.neutral50,
        border: `1px solid ${theme.colors.governorBay}`,
    },
    governorBayOutline: {
        bg: theme.newColors.neutral50,
        fontColor: theme.colors.governorBay,
        border: `1px solid ${theme.colors.governorBay}`,
    },
    disabled: {
        bg: theme.newColors.neutral200,
        fontColor: theme.newColors.neutral400,
        border: 'none',
    },
}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
    themeColor = 'astronautFont',
    sx,
    textProps,
    children,
    ...props
}) => {
    const mergedSx = useMemo(
        () => ({
            border: themeStyle[themeColor].border,
            '&:hover:not(:disabled)': {
                opacity: 0.6,
            },
            ...sx,
        }),
        [sx, themeColor],
    )
    const mergedtextProps = useMemo(
        () =>
            ({
                color: themeStyle[themeColor].fontColor,
                ...textProps,
            }) as TextProps,
        [textProps, themeColor],
    )
    return (
        <ButtonBase hasShadow bg={themeStyle[themeColor].bg} sx={mergedSx} textProps={mergedtextProps} {...props}>
            {children}
        </ButtonBase>
    )
}

export default ButtonPrimary
export const ButtonPrimaryLink = withLinkWrapper(ButtonPrimary)
